/* eslint-disable jsx-a11y/anchor-is-valid */
import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UrlParse from 'url-parse';

import { Alert, Form, Input, Button, Checkbox, Row, Col, Card } from 'antd';
import GeneralHelper from '../../helpers/general';
import Logo from '../../images/logo_colored.png';

class LoginPage extends Component {
	componentWillUnmount() {
		this.props.reset();
	}
	componentDidMount() {
		const query = GeneralHelper.queryStringToObject(this.props.location.search);
		this.props.showLoginForm({
			path: _.get(query, 'path')
		});
	}
	componentDidUpdate(prevProps, prevState) {
		const { meta: prevMeta } = prevProps.loginPageProps;
		const { meta } = this.props.loginPageProps;

		if(meta && meta !== prevMeta) {
			this.props.resetMeta();
		}
	}
	onFieldChange = name => (e) => {
		this.props.onFieldChange(name, e.target.value);
	}
	onKeyPress = e => {
		if (e.key === 'Enter') {
			this.onSubmit();
		}
	}
	onSubmit = e => {
		const { email, password } = this.props.loginPageProps;
		// const query = GeneralHelper.queryStringToObject(this.props.location.search);
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		this.props.login({ email, password, query });
	}
	render() {
		const { loginPageProps } = this.props;
		const { email, password, loading, error, showLoginForm } = loginPageProps;
		if (!showLoginForm) {
			return (<div></div>);
		}

		return (
			<Row
				style={{
					height: '100vh',
					display: 'flex', justifyContent: 'center', alignItems: 'center'
				}}
			>
				<Col
					xs={22}
					sm={18}
					md={14}
					lg={10}
					xl={8}
					style={{
						height: '100vh',
						display: 'flex', justifyContent: 'center', alignItems: 'center'
					}}
				>
					<Card style={{ borderRadius: 15, padding: '48px 40px 32px 40px', width: 480 }}>
						<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 25 }}>
							<div>
								<img
									alt="Hkust Logo"
									src={Logo}
									height={50}
								/>
							</div>
							<div style={{ marginLeft: 5, display: 'flex' }}>
								<div style={{ borderLeft: '1px solid #cce5ff', height: 70, marginRight: 5 }} />
								<div style={{ padding: 0, margin: 0 }}>
									<div style={{ color: '#003366', fontSize: 22, fontWeight: 'lighter' }}>CSO Transport Booking</div>
									<div style={{ color: '#003366', fontSize: 22, fontWeight: 'lighter' }}>Booker Login</div>
								</div>
							</div>
						</div>

						<Form
							name="normal_login"
							onFinish={this.onSubmit}
							initialValues={{ remember: true }}
						>
							{
								error &&
								<Form.Item>
									<Alert
										message={error}
										type="error"
										showIcon
									/>
								</Form.Item>
							}
							<h4 className="login-label" >Email Address</h4>
							<Form.Item
								name="email"
								value={email}
								onChange={this.onFieldChange('email')}
								rules={[
									{
										required: true,
										message: 'Please enter a email.'
									},
									{
										type: 'email',
										message: 'Please enter a valid email address.'
								  	}
								]}
							>
								<Input
									placeholder="Enter Email Address"
									style={{ borderRadius: 8, marginBottom: 0 }}
								/>
							</Form.Item>

							<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'  }}>
								<h4 className="login-label">Password</h4>
								<a
									href="#"
									style={{ textAlign: 'center' }}
								>Forgot Password?</a>
							</div>

							<Form.Item
								name="password"
								value={password}
								onChange={this.onFieldChange('password')}
								rules={[{ required: true, message: 'Please enter a password.' }]}
								style={{ margin: 0 }}
							>
								<Input
									style={{ borderRadius: 8 }}
									type="password"
									placeholder="Enter Password"
								/>
							</Form.Item>
							<div style={{ padding: '4px 0px' }}>
								<Checkbox
									style={{ color: 'rgba(0,0,0,.5)', marginBottom: 16 , fontSize: '12px' }}
								>Remember me?</Checkbox>
							</div>

							<Form.Item>
								<div style={{ textAlign: 'center' }}>
									<Button
										type="primary"
										htmlType="submit"
										disabled={loading}
										block
										style={{ borderRadius: 50, marginBottom: 12  }}
										size="large"
									>
									Login
									</Button>

									<Button
										disabled={loading}
										block
										size="large"
										onClick={this.props.showLoginForm}
										style={{ borderRadius: 50 }}
									>
									Login with CAS
									</Button>
								</div>
							</Form.Item>
						</Form>
					</Card>
				</Col>
			</Row>
		);
	}
}

LoginPage.propTypes = {
	loginPageProps: PropTypes.object.isRequired,
	onFieldChange: PropTypes.func.isRequired,
	login: PropTypes.func.isRequired
};

export default LoginPage;
